import React from "react";
import { useParams } from "react-router-dom";
import AudiosPlayScreen from "./AudioPlayScreen";
import AudioEpisodes from "./AudioEpisodes";
import AudioSeriesSlider from "./SimilarAudioEpisodes";
import { useChaptersBySeriesId } from "../../hooks/useChapters";
import Footer from "../../common/UI/Footer";
import Loading from "../../common/HousGlass Loader/Loading";
import { useAudioBySlug } from "../../hooks/useAudiosHooks";
import { Helmet } from "react-helmet"; // ✅ import Helmet

const AudioPlay = () => {
  const { slug } = useParams();

  const {
    data: audioData,
    isLoading,
    error
  } = useAudioBySlug(slug);

  const seriesId = audioData?.series_id || audioData?.series?.id;

  const {
    series,
    chapters,
    isLoading: isLoadingChapters,
    error: chaptersError,
  } = useChaptersBySeriesId(seriesId);

  if (isLoading || (seriesId && isLoadingChapters)) {
    return <Loading />;
  }

  if (error) {
    return <div>Error loading audio: {error.message}</div>;
  }

  if (audioData && !seriesId && audioData.requiresSeries) {
    return <div>Error loading series</div>;
  }

  if (seriesId && chaptersError) {
    return <div>Error loading chapters: {chaptersError.message}</div>;
  }

  const seriesData = audioData?.series || (seriesId ? { id: seriesId } : null);

  return (
    <>
      {/* ✅ Set dynamic tab title */}
      <Helmet>
        <title>{audioData?.page_title ? `${audioData.page_title} - SunoKahaniyan` : (audioData?.title ? `${audioData.title} - SunoKahaniyan` : "SunoKahaniyan")}</title>
        <meta name="description" content={audioData?.meta_description || audioData?.description || "Listen to audio stories on SunoKahaniyan"} />
        <meta name="keywords" content={audioData?.meta_keywords || "audio, stories, SunoKahaniyan"} />
      </Helmet>

      <AudiosPlayScreen audioData={audioData} series={series} chapters={chapters} />
      
      {seriesId && chapters && chapters.length > 0 && (
        <AudioEpisodes
          seriesId={seriesId}
          chapters={chapters}
          seriesData={seriesData}
        />
      )}

      <AudioSeriesSlider audioData={audioData} />
      <Footer />
    </>
  );
};

export default AudioPlay;
